import { useEffect, useState } from 'react'

export function useNowTick(active: boolean, intervalMs = 1000): void {
  const [, setTick] = useState(0)

  useEffect(() => {
    if (!active) return
    const id = window.setInterval(() => setTick(n => n + 1), intervalMs)

    return () => window.clearInterval(id)
  }, [active, intervalMs])
}
